import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useSearchBox } from 'react-instantsearch'

import { decodeDiscoverQuery, isDiscoverPage } from 'utils/search/search-url-mapping'

const SearchBoxVirtual = () => {
  const router = useRouter()
  const { refine: setQuery } = useSearchBox()

  useEffect(() => {
    if (isDiscoverPage()) {
      setQuery(decodeDiscoverQuery(router.query.query as string))
    } else {
      setQuery(router.query.query as string)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.query])

  return null
}

export default SearchBoxVirtual
